import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '@reduxjs/toolkit/query'
import { persistor } from 'store'
import Api from "services/api"

export const initUser = {
  token: undefined,
  user: undefined,
  intro: true,
  loader: false,
  isAuthenticated: false,
  error: {}
}

// export const initialState: IUserState = {
//   name: '',
//   drawerOpen: false,
//   user: {
//     name: 'Chintan',
//     email: 'chintan@gmail.com',
//     phone: '+91 9999999999'
//   },
//   intro: true,
//   loader: false,
//   keyboardVisible: false
// }

export const userSlice = createSlice({
  name: 'user',
  initialState: initUser,
  reducers: {
    setUser: (state, { payload }) => {
      state.user = payload.data
      state.isAuthenticated = true;
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
    setIntro: (state, { payload }) => {
      state.intro = payload
    },
    setLogout: (state, { payload }) => {
      state.user = payload
      state.isAuthenticated = false;
    },
  }
})

// const reducer = (state = initialState, action) => {
//   switch (action.type) {
//     case types.INIT_APP:
//     case types.GO_TO_DETAILS:
//       return { ...state, ...action.payload }
//     default:
//       return state
//   }
// }

export const login = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.login(data)
    if (json.status >= 200 && json.status < 300) {
      dispatch(setUser(json.data))
      Api.setClientToken(json?.data?.data?.token);
      callback(true)
    } else {
      // 401 invalid credentials, 403 inactive account, … — surface the API's message
      dispatch(setError(json.data))
      callback(false, json?.data?.message)
    }
  } catch (error) {
    console.log(error)

  }
  dispatch(setLoader(false))
  // return json;
};

// register
export const register = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.signup(data)
    if (json.status >= 200 && json.status < 300) {
      dispatch(setUser(json.data))
      Api.setClientToken(json?.data?.data?.token);
      callback(true)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
  // return json;
};


export const forgotPassword = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.forgotPassword(data)
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message, json.data?.token)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
    else {
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
  // return json;
};


export const validateResetToken = (data, callback) => async (dispatch) => {
  dispatch(setError({}))
  try {
    const json = await Api.validateResetToken(data)
    if (json?.status >= 200 && json?.status < 300) {
      callback(true, json.data.message)
    } else {
      callback(false, json?.data?.message || "This password reset link is invalid or has expired. Please request a new one.")
    }
  } catch (error) {
    console.log(error)
    callback(false, "Could not verify your reset link. Please check your connection and try again.")
  }
};

export const resetPassword = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.resetPassword(data)
    if (json?.status >= 200 && json?.status < 300) {
      callback(true, json.data.message)
    } else if (json?.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    } else {
      // Anything else (400 invalid/expired token, 500, no response) previously fell
      // through here silently — the user saw no message at all
      callback(false, json?.data?.message || "Could not reset your password. Please request a new reset link and try again.")
    }
  } catch (error) {
    console.log(error)
    callback(false, "Could not reset your password. Please check your connection and try again.")
  }
  dispatch(setLoader(false))
  // return json;
};

// ---- Ghost login (admin impersonates an interpreter) --------------------------
// The admin session is stashed under this localStorage key while ghosting, so the
// interpreter layout can offer "Return to Admin" without a re-login.
export const GHOST_ADMIN_KEY = 'ghost_admin_session';

export const ghostLogin = (interpreterId, callback) => async (dispatch, getState) => {
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    const json = await Api.ghostLoginInterpreter(interpreterId)
    if (json?.status >= 200 && json?.status < 300) {
      const adminSession = getState()?.user?.user;
      if (adminSession?.token) {
        localStorage.setItem(GHOST_ADMIN_KEY, JSON.stringify(adminSession));
      }
      dispatch(setUser(json.data))
      Api.setClientToken(json?.data?.data?.token);
      callback(true, json?.data?.message)
    } else {
      callback(false, json?.data?.message || "Ghost login failed.")
    }
  } catch (error) {
    console.log(error)
    callback(false, "Ghost login failed. Please try again.")
  }
  dispatch(setLoader(false))
};

export const returnFromGhost = (callback) => async (dispatch) => {
  try {
    const stored = localStorage.getItem(GHOST_ADMIN_KEY);
    if (!stored) {
      callback && callback(false);
      return;
    }
    const adminSession = JSON.parse(stored);
    localStorage.removeItem(GHOST_ADMIN_KEY);
    Api.setClientToken(adminSession?.token);
    dispatch(setUser({ data: adminSession }))
    callback && callback(true)
  } catch (error) {
    console.log(error)
    callback && callback(false)
  }
};

export const logout =
  (navigation, routes, ndispatch) => async (dispatch) => {

    persistor.purge() // Clears the persisted state
    dispatch(setLogout(initUser))
    localStorage.removeItem(GHOST_ADMIN_KEY); // never leave a stashed admin token behind
    setTimeout(() => {
      localStorage.removeItem("persist:root");
      localStorage.removeItem(GHOST_ADMIN_KEY);

      persistor.purge() // Clears the persisted state
      localStorage.removeItem("persist:root");
      window.location.reload("/login")
    }, 500);
  }

export const { setUser, setLoader, setError, setIntro, setLogout } = userSlice.actions
export const userSelector = state => state.user


export default userSlice.reducer
